import React from "react";
import { Link } from "react-router-dom";

const IMG_MAIN = "https://images.unsplash.com/photo-1609619742069-f5e18afeef17?auto=format&fit=crop&w=1800&q=85";
const IMG_2 = "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&w=1600&q=85";

export default function About() {
    return (
        <div className="bg-paper">
            <section className="max-w-[1480px] mx-auto px-6 lg:px-12 pt-20 pb-12 text-center border-b border-soft">
                <p className="overline">Our Story</p>
                <h1 className="font-serif text-5xl sm:text-7xl text-ink mt-4 max-w-4xl mx-auto leading-[1]">
                    A workshop. A family.<br/>
                    <span className="serif-em text-bronze-deep">A standard kept for three generations.</span>
                </h1>
            </section>

            <section className="max-w-[1480px] mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-12 gap-10">
                <div className="md:col-span-7">
                    <img src={IMG_MAIN} alt="Atelier" className="w-full aspect-[4/3] object-cover" />
                </div>
                <div className="md:col-span-5">
                    <p className="overline">The Manufacturer</p>
                    <h2 className="font-serif text-3xl text-ink mt-3 leading-snug">
                        Gold by SRN is a wholesale manufacturer — never a retailer.
                    </h2>
                    <p className="mt-5 text-charcoal leading-relaxed">
                        We exist for the trade. From a single bench in Jaipur's Johari Bazar, our family has spent decades building a reputation for honest karatage, intricate hand-work and reliable timelines. We do not sell to consumers directly — every piece we make ends up on a small jeweller's shelf somewhere in India.
                    </p>
                    <p className="mt-4 text-charcoal leading-relaxed">
                        Our customers include independent jewellers across Rajasthan, Gujarat, Maharashtra, Karnataka and beyond. We're proud to power their growth quietly — without taking the spotlight ourselves.
                    </p>
                </div>
            </section>

            <section className="bg-ivory">
                <div className="max-w-[1480px] mx-auto px-6 lg:px-12 py-20 grid md:grid-cols-3 gap-10">
                    {[
                        { n: "01", t: "Bring the brief", d: "Send us a sketch, reference image or just a description. Our design team translates it to CAD in 24–48 hours." },
                        { n: "02", t: "Approve a sample", d: "We make a physical sample. You approve weight, finish and silhouette. No surprises later." },
                        { n: "03", t: "Bulk production", d: "Once approved, we manufacture in your required quantities, hallmark and dispatch — insured, pan-India." },
                    ].map((s) => (
                        <div key={s.n} className="border-l border-bronze pl-6">
                            <p className="overline">Step {s.n}</p>
                            <h3 className="font-serif text-2xl text-ink mt-3">{s.t}</h3>
                            <p className="mt-3 text-sm text-charcoal leading-relaxed">{s.d}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="max-w-[1480px] mx-auto px-6 lg:px-12 py-20 grid md:grid-cols-12 gap-10 items-center">
                <div className="md:col-span-5 order-2 md:order-1">
                    <p className="overline">Our Promise</p>
                    <h2 className="font-serif text-4xl text-ink mt-3 leading-tight">Honest manufacturing, every piece.</h2>
                    <ul className="mt-6 space-y-3 text-sm text-charcoal">
                        <li className="flex gap-3"><span className="text-bronze-deep">—</span>Three generations of craftsmen, in-house</li>
                        <li className="flex gap-3"><span className="text-bronze-deep">—</span>Custom designs &amp; bespoke CAD on request</li>
                        <li className="flex gap-3"><span className="text-bronze-deep">—</span>BIS hallmarking on every piece</li>
                        <li className="flex gap-3"><span className="text-bronze-deep">—</span>Transparent making charges, honest karatage</li>
                        <li className="flex gap-3"><span className="text-bronze-deep">—</span>Direct WhatsApp line to our atelier</li>
                    </ul>
                    <Link to="/contact" data-testid="about-cta-contact" className="inline-block mt-10 px-8 py-4 bg-ink text-paper uppercase text-[11px] tracking-[0.26em] hover:bg-bronze-deep">Talk to us on WhatsApp</Link>
                </div>
                <div className="md:col-span-7 order-1 md:order-2">
                    <img src={IMG_2} alt="Crafted gold" className="w-full aspect-[5/4] object-cover" />
                </div>
            </section>
        </div>
    );
}
